import React, { useEffect, useState } from 'react'
import { Logo } from '../../../components/Logo/Logo'
import classes from './EmployerStep.module.css'
import { NavText } from '../../../components/NavElements'
import { Button } from '../../../components/Button/Button'
import TextField from '../../../components/TextField/TextField'
import { Picker } from '../../../components/Picker/Picker'
import { useLocation, useHistory } from 'react-router'
import B from '../../../assets/B2.jpg'
import styled, { keyframes } from 'styled-components';
import { fadeInDown } from 'react-animations';
import { serverConn } from '../../../API/apiRequest'
import validator from 'validator' 
import { useDispatch } from 'react-redux'
import { login } from '../../../State/Slice/userSlice'

const bounceAnimation = keyframes`${fadeInDown}`;
 
const AnimDiv = styled.div`
  animation: 1.2s ${bounceAnimation};
`;
interface Props {

}

interface stateType {
    name: string,
    placeName: string,
    password: string
    phone: string,
    email: string
    placeType: {label: string, value: string}
}


export const EmployerStep: React.FC<Props> = (props) => {
    const { state } = useLocation<stateType>()
    const dispatch = useDispatch()
    const { pathname } = useLocation()
    const [placePhone, setPlacePhone] = useState<string>('')
    const [placeEmail, setPlaceEmail] = useState<string>('')
    const [placeAddress, setPlaceAddress] = useState<string>('')
    const [employeesOption, setEmployeesOption] = useState<[{label: string, value: string}] | []>([])
    const [loadingEmployees, setLoadingEmployees] = useState<boolean>(true)
    const [employees, setEmployees] = useState<{label: string, value: string} | null>(null)
    const [fields, setFields] = useState<[{label: string, value: string}] | []>([])
    const [loadingFields, setLoadingFields] = useState<boolean>(true)
    const [field, setField] = useState<{label: string, value: string} | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [err, setErr] = useState<string>('')
    const history = useHistory()

    useEffect(()=>{
        window.scrollTo(0, 0)
        if(!state) return history.replace('/register')
        if(!state.name || !state.email || !state.placeType) return history.replace('/register')

        async function getData(){
            try{
                let E_result = await serverConn.get('/config/employees') 
                let F_result = await serverConn.get('/config/fields')

                setFields(F_result.data.fields)
                setEmployeesOption(E_result.data.employees)
                setLoadingEmployees(false)
                setLoadingFields(false)

            }catch(e){
                console.log(e)
            }
        }
        getData()
    },[pathname, state, history])



    const onSignup = async()=>{
        try{
            if(placePhone.trim() === '') return setErr('رقم هاتف المكان غير صحيح')
            if(!validator.isEmail(placeEmail)) return setErr('بريد الكتروني غير صحيح')
            if(placeAddress.trim() === '') return setErr('من فضلك ادخل العنوان')
            if(field === null) return setErr('من فضلك اختر المجال')
            if(employees === null) return setErr('من فضلك اختر عدد العمالة')

            setErr('')
            setLoading(true)
            let result = await serverConn.post('/signup/er', {
                name: state.name,
                email: state.email,
                phone: state.phone,
                password: state.password,
                placeTitle: state.placeName,
                placeType: state.placeType.value,
                placePhone,
                placeField: field.value,
                placeEmail,
                placeSize: employees.value,
                address: placeAddress
            })
            if(result.status === 201){
                setLoading(false)
                await localStorage.setItem('user', JSON.stringify(result.data))
                dispatch(login({
                    type: result.data.type,
                    name: result.data.name,
                    companyName: result.data.companyName,
                    picture: result.data.picture,
                    refresh: result.data.refreshToken,
                    logId: result.data.log
                }))
            }
        }catch(e: any){
            if(e.response){
                if(e.response.data.errors)
                setErr(e.response.data.errors[0])
            }
            setLoading(false)
            console.log(e)
        }
    }


    return (
        <div className={classes.container}>
            <div className={classes.logoContainer}>
            <NavText to='/'><Logo /></NavText>
            </div>
            <div className={classes.all}>
                <div className={classes.left}>
                    <div className={classes.moreInfo}>
                        <div>
                            <p className={classes.label}>رقم الهاتف الخاص بالعمل</p>
                            <TextField 
                                containerStyle={{margin: 5}} 
                                bgColor='#1D252D' 
                                iconName={'FiPhone'} 
                                placeholder='رقم الهاتف'
                                width={200}
                                value={placePhone}
                                handleChange={({target})=>setPlacePhone(target.value)}

                            />
                        </div>
                        <div>
                            <p className={classes.label}>البريد الإلكتروني الخاص بالعمل</p>
                            <TextField 
                                containerStyle={{margin: 5}} 
                                bgColor='#1D252D' 
                                iconName={'FiMail'} 
                                placeholder='ايميل'
                                width={200}
                                value={placeEmail}
                                handleChange={({target})=>setPlaceEmail(target.value)}
                            />
                        </div>
                        <div>
                            <p className={classes.label}>العنوان (داخل مدينة السادات)</p>
                            <TextField 
                                containerStyle={{margin: 5}} 
                                bgColor='#1D252D' 
                                iconName={'FiMapPin'} 
                                placeholder='عنوان'
                                width={200}
                                value={placeAddress}
                                handleChange={({target})=>setPlaceAddress(target.value)}

                            />
                        </div>
                        <div>
                            <p className={classes.label}>عدد العمالة الحالية</p>
                            <Picker 
                                options={employeesOption}
                                loading={loadingEmployees}
                                value={employees}
                                onChange={(value)=>setEmployees(value)}  
                                placeholder='عدد العمالة'

                            />
                        </div>
                        <div>
                            <p className={classes.label}>مجال العمل</p>
                            <Picker 
                                options={fields}  
                                placeholder='المجالات'
                                loading={loadingFields}
                                value={field}
                                onChange={(value)=>setField(value)}
                            />
                        </div>
                    </div>
                </div>
                <div className={classes.right}>
                    <div>
                        <AnimDiv className={classes.welcome}>
                            <p>مرحباً بك</p>
                        </AnimDiv>
                        <p className={classes.tip}>يرجي استكمال بعض البيانات</p>
                    </div>
                    <img alt='B' src={B} className={classes.img}/>
                </div>
            </div>
            <div style={{
                    height: 30,
                    marginTop: 10}}>
                    {err && <p style={{color: 'rgb(255, 116, 116)', textAlign: 'center', margin: 0, padding: 0}}>
                        {err}
                    </p>}
            </div>
            <Button 
                style={{marginTop: 5}} 
                loading={loading} 
                onPress={onSignup} 
                color='#5A8D59'>التالي</Button>
        </div>
    )
}